(function ($) {
    var sportdataSearchPanelClass = {};
    sportdataSearchPanelClass.run = function (panelInstance) {
        // private variables
        var thisSearchPanel = $(panelInstance);
        if (!$(thisSearchPanel).hasClass("sportdata-search-panel")) {
            thisSearchPanel = $(panelInstance).closest(".sportdata-search-panel");
        }

        // private methods
        var setPosition = function () {
            var navbar = $("nav.navbar.fixed-top").first();
            if (navbar.length === 1) {
                thisSearchPanel.css({
                    "top": (navbar.offset().top + navbar.outerHeight() + 1) + "px",
                    "left": navbar.offset().left + "px"
                });
            }
        };
        var toggle = function (trigger) {
            if (thisSearchPanel.hasClass('open')) {
                $(".sportdata-search-panel-trigger .bfc-open-icon").stop(true).show();
                $(".sportdata-search-panel-trigger .bfc-close-icon").stop(true).hide();
            } else {
                $(".sportdata-search-panel-trigger .bfc-open-icon").stop(true).hide();
                $(".sportdata-search-panel-trigger .bfc-close-icon").stop(true).show();
                setTimeout(function () {
                    thisSearchPanel.find('input').first().focus();
                }, 100);
            }
            thisSearchPanel.toggleClass('open');
        };

        // public API
        return {
            setPosition: setPosition,
            toggle: toggle
        };
    };

    var searchPanelPositioningTimer = null;
    var sportdataSearchPanel = new sportdataSearchPanelClass.run($(".sportdata-search-panel").first());

    $(".sportdata-search-panel-trigger").on("click", function (event) {
        event.stopPropagation();
        sportdataSearchPanel.toggle();
    });
    $(window).resize(function () {
        if (searchPanelPositioningTimer !== null) {
            clearTimeout(searchPanelPositioningTimer);
        }
        searchPanelPositioningTimer = setTimeout(function () {
            sportdataSearchPanel.setPosition();
        }, 300);
    }).resize();
})(jQuery);
